import { useContext } from 'react';
import type { SpLogicSignGateApi } from '@sp-api/sign-gate-api';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function useSignGateApiClient(): SpLogicSignGateApi {
  const { signGateApi } = useContext(ApiContext);

  return signGateApi;
}
